import React, { Component } from 'react';
import PropTypes from 'prop-types';


const stylesheet = {
  base: {

  },
  text: {
    paddingRight: 5 + 'px',
    paddingTop: 3 + 'px',
    paddingBottom: 3 + 'px',
    fontSize: 11 + 'px',
    color: '#D20000',
    animationDuration: 0.5 + 's',
    margin: 0 + 'px',
    fontWeight: 'bold',
  },
  hidden: {
    display: 'none'
  }
};

class WarningComponent extends Component {

  constructor(props) {
    super(props);
  }

  render() {
    const {visible, info} = this.props;

    return (
      <div style={visible ? stylesheet.base : stylesheet.hidden} className="animated fadeIn">
        <p  style={stylesheet.text}>{info}</p>
      </div>
    );
  }
}

WarningComponent.propTypes = {
    label: PropTypes.string,
  visible: PropTypes.any,
  info: PropTypes.any,
};

export default WarningComponent;
